// removed by extract-text-webpack-plugin
module.exports = {"row":"UsefulTools-row-1695a6e8","col":"UsefulTools-col-1df67aff","button":"UsefulTools-button-71c04337","bannerAd":"UsefulTools-bannerAd-98cd56a4","rail":"UsefulTools-rail-bee1d9d4","usefulToolsContainer":"UsefulTools-usefulToolsContainer-3ef9f980","cardsGrid":"UsefulTools-cardsGrid-2aaefc05"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UsefulTools/UsefulTools.scss
// module id = 896
// module chunks = 0